<template>
    <!-- Rus - Geo -->
    <template v-if="reversed">
        {{ rus }} –
        <voice
            type="vocabulary"
            v-bind="$attrs"
        >
            {{ geo }}
        </voice>
    </template>

    <!-- Geo - Rus -->
    <template v-else>
        <voice
            type="vocabulary"
            v-bind="$attrs"
            :is-composite="true"
        >
            {{ geo }}
        </voice>
        – {{ rus }}
    </template>
</template>

<script>
import Voice from '@components/Voice.vue'

export default {
    name: 'Word',
    components: {
        Voice,
    },
    props: {
        geo: {
            type: String,
            default: '',
        },
        rus: {
            type: String,
            default: '',
        },
        reversed: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
